module.exports = __webpack_public_path__ + "static/media/LDB-Wellness-Process-01.c0110f7b.mp4";